import { oz } from '@weft/utils';
import { INTEGRATION_PROVIDERS } from '../integration-providers-schema';
import { NetSuiteOAuthDataSchema } from './net-suite-oauth-data-schema';

export const NetSuiteOAuthSchema = NetSuiteOAuthDataSchema.extend({
  integrationProvider: oz.literal(INTEGRATION_PROVIDERS.netSuite),
}).openapi('NetSuiteOAuth');

export type NetSuiteOAuth = oz.infer<typeof NetSuiteOAuthSchema>;